import React, {useMemo} from 'react'
import styled from 'styled-components'
import {Paragraph} from 'common/components'
import convertUnit from 'lib/unit'
import {TransactionBankAccountListItemProps} from './TransactionBankAccountListItemProps'

const StyledContainer = styled.div`
  border-radius: ${convertUnit(8)};
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
`
const StyledBankContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`

const StyledStatusContainer = styled.div`
  display: flex;
  flex-direction: row;
`

const StyledParagraph = styled(Paragraph)`
  margin-right: ${convertUnit(4)};
`

export default function TransactionBankAccountListItem({
  accountName,
  accountNumber,
  bankName,
}: TransactionBankAccountListItemProps) {
  const handleRenderBankCode = useMemo(
    () => (
      <StyledParagraph fontSize="s" fontWeight="bold" color="primary_5">
        {`${bankName} • `}
      </StyledParagraph>
    ),
    [bankName],
  )

  return (
    <StyledContainer>
      <StyledBankContainer>
        <Paragraph fontSize="m" fontWeight="bold" color="black">
          {accountName.toUpperCase()}
        </Paragraph>
        <StyledStatusContainer>
          {handleRenderBankCode}
          <Paragraph fontSize="s" fontWeight="medium" color="gray_5">
            {accountNumber}
          </Paragraph>
        </StyledStatusContainer>
      </StyledBankContainer>
    </StyledContainer>
  )
}
